import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContinuousAssessmentModel } from '../../model/continuous_assessment.model';
import { ContinuousAssessmentService } from '../../providers/continuous_assessment.service';

@Component({
	selector: 'app-continous-assesment-edit-dialog',
	templateUrl: './continous-assesment-edit-dialog.component.html',
	styleUrls: [ './continous-assesment-edit-dialog.component.css' ]
})
export class ContinousAssesmentEditDialogComponent implements OnInit {
	selectedItem: ContinuousAssessmentModel;
	errorMessage: string = '';
	isLoading: boolean = true;

	constructor(
		private fb: FormBuilder,
		private mApiService: ContinuousAssessmentService,
		private _snackBar: MatSnackBar,
		private dialogRef: MatDialogRef<ContinousAssesmentEditDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {
		this.selectedItem = this.data;
	}

	saveEdit() {
		this.mApiService.editContinuousAssessment(this.selectedItem).subscribe(
			(p) => {
				//  this.varShowEditDialog=false;
				this.dialogRef.close();
			},
			(e) => (this.errorMessage = e),
			() => (this.isLoading = false)
		);
	}
}
